$.ajaxSetup({ cache: false });
function addToCartBubbleItem(productID) {
    var variantID = $('#dropdown-variant-id-' + productID).val();
    var formObj = {
        quantity: 1,
        id: variantID
    };

    jQuery.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: formObj,
        dataType: 'json',
        async: true,
        success: function(data) {
            $('#btnGroup-' + productID).find('.cart-drawer-loader .loading__spinner').removeClass('hidden');
            $('#btnGroup-' + productID).find('.add-to-cart-product-btn').hide();
            $.ajax({
                url: '/cart.js',
                method: 'GET',
                dataType: 'json',
                success: function(cartData) {
                    var isInCart = cartData.items.some(item => item.product_id == productID);
                    
                    if (isInCart) {
                        $('#btnGroup-' + productID).find('.cart-drawer-loader .loading__spinner').addClass('hidden');
                        $('#btnGroup-' + productID).find('.quantity-main-div-' + productID).fadeIn("slow");
                        $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
                        $('#quantityInput-' + productID).show();
                        showSuccessNotification("Product added to cart successfully!");
                    } else {
                        $('#btnGroup-' + productID).find('.add-to-cart-product-btn').show();
                        $('#btnGroup-' + productID).find('.quantity-main-div-' + productID).hide();
                    }
                  refreshCartDrawer(); 
                },
                error: function(xhr, status, error) {
                    console.log('Error - ' + xhr.status + ': ' + xhr.statusText);
                }
            });
        },
    });
    
    return false;
}


// quantity increment in collection page start
function quantityIncrement(productID, productHandle) {
    var variantIdNew = parseInt($('#dropdown-variant-id-' + productID).val());
    var quantityInput = $('#Quantity-' + productID);
    var userSelectedQuantity = parseInt(quantityInput.val(), 10);

    $.ajax({
        url: `/products/${productHandle}.json`,
        method: 'GET',
        dataType: 'json',
        success: function(productData) {
            var availableStock = getVariantStock(productData, variantIdNew);
            if (availableStock === null || availableStock >= userSelectedQuantity) {
                addToCart(variantIdNew, userSelectedQuantity, productID);
            } else {
                quantityInput.val(availableStock);
                $("#stock-message-" + productID).text("Only " + availableStock + " items available.").removeClass("hidden");
                addToCart(variantIdNew, availableStock, productID);
            }
        },
        error: function() {
            addToCart(variantIdNew, userSelectedQuantity, productID);
        }
    });
}

// **Function to Add to Cart**
function addToCart(variantId, quantity, productID) {
    $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: { quantity: quantity, id: variantId },
        dataType: 'json',
        success: function(data) {
            updateCart();
            $("#stock-message-" + productID).addClass("hidden");
        },
        error: function(xhr) {
            if (xhr.status === 422) {
                var response = JSON.parse(xhr.responseText);
                var stockLimitMessage = response.description || "";

                var match = stockLimitMessage.match(/Only (\d+) items were added/);
                var availableStock = match && match[1] ? parseInt(match[1], 10) : null;

                if (availableStock) {
                    var currentQuantity = parseInt($("#Quantity-" + productID).val(), 10) || 1;
                    var newQuantity = Math.min(quantity, availableStock); 

                    $("#Quantity-" + productID).val(newQuantity); 
                    $("#stock-message-" + productID).text("Only " + availableStock + " items available in stock.").removeClass("hidden");
                } else {
                    // Fetch actual available stock from the cart
                    $.ajax({
                        url: "/cart.js",
                        method: "GET",
                        dataType: "json",
                        success: function(cartData) {
                            var cartItem = cartData.items.find(item => item.id === variantId);
                            var actualStock = cartItem ? cartItem.quantity : "Unknown"; 

                            $("#stock-message-" + productID).text("Only " + actualStock + " items available in stock.").removeClass("hidden");
                            $("#Quantity-" + productID).val(actualStock); // Strictly update quantity
                        },
                        error: function() {
                            $("#stock-message-" + productID).text("Stock information unavailable.").removeClass("hidden");
                        }
                    });
                }
            } else {
                $("#stock-message-" + productID).text("An error occurred. Please try again.").removeClass("hidden");
            }
        }
    });
}



function getVariantStock(productData, variantId) {
    var variant = productData.product.variants.find(v => v.id === variantId);
    return variant ? variant.inventory_quantity : null;
}

function updateCart() {
    $.ajax({
        url: '/cart.js',
        method: 'GET',
        dataType: 'json',
        success: function(cartData) {
            var itemsCount = cartData.item_count;
            updateCartDrawer();
            updateCartIconBubble(itemsCount);
            showSuccessNotification("Product added to cart successfully!");
            $(".stock-message").addClass("hidden");
        }
    });
}


// quantity increment in collection page end

// quantity decrement in collection page start
function quantityDecrement(productID) {
    let quantityval = parseInt($('#Quantity-' + productID).val());
    let variantIdNew = parseInt($('#dropdown-variant-id-' + productID).val());

    if (quantityval <= 1) {
        // Remove item from cart when quantity is 0
        jQuery.ajax({
            url: '/cart/change.js', // Replace with your actual URL
            method: 'POST',
            data: { quantity: 0, id: variantIdNew }, // Remove item from cart
            dataType: 'json',
            success: function(data) {
                updateCartIconBubble(data.item_count);
                // Hide quantity selector and show "Add to Cart" button
                $('#quantityInput-' + productID).hide();
                $('.add-to-cart-main-btn-' + productID).show();
                showSuccessNotification("Product deleted Successfully!");
            },
            error: function(xhr, status, error) {
                console.log('Error - ' + xhr.status + ': ' + xhr.statusText);
            }
        });
    } else {
        // Decrease quantity normally
        let formObj = {
            quantity: quantityval - 1,
            id: variantIdNew
        };

        jQuery.ajax({
            url: '/cart/change.js', 
            method: 'POST',
            data: formObj,
            dataType: 'json',
            success: function(data) {
                $.ajax({
                    url: '/cart.js',
                    method: 'GET',
                    dataType: 'json',
                    success: function(cartData) {
                        updateCartDrawer();
                        updateCartIconBubble(cartData.item_count);
                        $('#quantityInput-' + productID).show();
                        $('.add-to-cart-main-btn-' + productID).hide();
                        showSuccessNotification("Quantity of this item has been reduced");
                    },
                    error: function(xhr, status, error) {
                        consoel.log('Error - ' + xhr.status + ': ' + xhr.statusText);
                    }
                });
            },
            error: function(xhr, status, error) {
                consoel.log('Error - ' + xhr.status + ': ' + xhr.statusText);
            }
        });
    }
    return false;
}

// quantity decrement in collection page start
function updateCartIconBubble(itemCount) {
   $('#cart-icon-bubble .cart-count-bubble span').text(itemCount);
}

//fetch quantity value according to item added in cart start
$(document).ready(function() {
    var fetchedQuantities = false;
    function fetchAndSetProductQuantities() {
        if (!fetchedQuantities) {
            $.ajax({
                url: '/cart.js', // URL to fetch the cart data
                method: 'GET',
                dataType: 'json',
                success: function(data) {
                    data.items.forEach(function(item) {
                        var productId = item.variant_id;
                        var quantity = item.quantity;
                        $('.quantity-' + productId).val(quantity); // Set the quantity explicitly
                    });
                },
                error: function(xhr, status, error) {
                    console.error('Error fetching cart data:', error);
                }
            });
            fetchedQuantities = true;
        }
    }

    // Call the function to fetch and set product quantities when the page loads
    fetchAndSetProductQuantities();
});
//fetch quantity value according to item added in cart end

function refreshCartDrawer() {
    $.ajax({
        url: '/cart.js', // Fetch updated cart data
        method: 'GET',
        dataType: 'json',
        success: function(cartData) {
            if (cartData.items.length > 0) {
                $("cart-drawer").addClass("animate active").removeClass("is-empty");
                $("cart-drawer").load(location.href + " #CartDrawer");
                $("cart-drawer").load(" cart-drawer>*", '');
            } else {
                $("cart-drawer").removeClass("active").addClass("is-empty");
            }
        },
        error: function() {
            console.error("Failed to refresh cart drawer.");
        }
    });
}

function updateCartDrawer() {
    $.ajax({
        url: '/cart.js', // Fetch updated cart data
        method: 'GET',
        dataType: 'json',
        success: function(cartData) {
            if (cartData.items.length > 0) {
                $("cart-drawer").load(location.href + " #CartDrawer");
                $("cart-drawer").load(" cart-drawer>*", '');
            } else {
                $("cart-drawer").removeClass("active").addClass("is-empty");
            }
        },
        error: function() {
            console.error("Failed to refresh cart drawer.");
        }
    });
}


//wishlist code

$(document).ready(function () {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // On load: mark buttons as active if product is in wishlist
  $('.wishlist-button').each(function () {
    const handle = $(this).data('product-handle');
    if (wishlist.includes(handle)) {
      $(this).addClass('active');
    }
  });

  // On click: toggle wishlist and active class
  $('.wishlist-button').on('click', function () {
    const handle = $(this).data('product-handle');
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      showSuccessNotification("Added to Wishlist!");
    } else {
      wishlist = wishlist.filter(h => h !== handle);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      showSuccessNotification("Removed from Wishlist!");
    }

    $(this).toggleClass('active');
    updateWishlistCount();
  });

  function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const $countEl = $('#wishlist-count');

    if (wishlist.length > 0) {
      $countEl.text(wishlist.length).show();
    } else {
      $countEl.text('').hide();
    }
  }

  updateWishlistCount(); // Call on page load
});

function showSuccessNotification(message) {
    // Remove existing notification if any
    $('#success-notification').remove();
    
    // Append new notification
    $('body').append(`
        <div id="success-notification" class="success-notification">
            <p><span class="checkmark-icon"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg></span>${message}</p>
        </div>
    `);

    $('#success-notification').fadeIn("slow").delay(2000).fadeOut("slow", function() {
        $(this).remove();
    });
}

// progress bar in cart
(function() {
  // Thresholds
  const freeShippingThreshold = 450;
  const discountThreshold = 1499;
  const maxTarget = discountThreshold;

  // Elements
  const fillBar = document.querySelector(".progress-bar-fill");
  const msg = document.getElementById("progress-message");
  const freeShipEmoji = document.querySelector(".milestone-free-shipping");
  const discountEmoji = document.querySelector(".milestone-discount");
  const confettiCanvas = document.getElementById("confetti-canvas");

  if (!fillBar || !msg || !freeShipEmoji || !discountEmoji || !confettiCanvas) {
    console.warn("Required elements missing!");
    return;
  }

  // Setup confetti scoped to canvas
  const confetti = window.confetti.create(confettiCanvas, {
    resize: true,
    useWorker: true,
  });

  let lastTotal = -1;
  let confettiLaunched = false;

  // Launch confetti from a specific element
  function launchConfettiFromElement(el) {
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const canvasRect = confettiCanvas.getBoundingClientRect();

    const x = (rect.left + rect.width / 2 - canvasRect.left) / canvasRect.width;
    const y = (rect.top + rect.height / 2 - canvasRect.top) / canvasRect.height;

    confetti({
      particleCount: 100,
      spread: 90,
      origin: { x, y }
    });
  }

  // Update progress bar UI
  function updateProgressBar(cartTotal) {
    if (typeof cartTotal !== "number" || cartTotal < 0) return;

    if (cartTotal === lastTotal) return;
    lastTotal = cartTotal;

    let percentage = Math.min((cartTotal / maxTarget) * 100, 100);
    fillBar.style.width = percentage + "%";

    // Update free shipping emoji
    if (cartTotal >= freeShippingThreshold) {
      // freeShipEmoji.textContent = "🔓";
      freeShipEmoji.style.opacity = 1;
    } else {
      // freeShipEmoji.textContent = "🔒";
      freeShipEmoji.style.opacity = 0.7;
    }

    // Update discount emoji
    if (cartTotal >= discountThreshold) {
      discountEmoji.style.opacity = 1;
    } else {
      discountEmoji.style.opacity = 0.7;
    }

    // Update message text
    if (cartTotal < freeShippingThreshold) {
      msg.textContent = `Add $${(freeShippingThreshold - cartTotal).toFixed(2)} more for FREE SHIPPING.`;
    } else if (cartTotal < discountThreshold) {
      msg.textContent = `🔓 FREE SHIPPING unlocked! Add $${(discountThreshold - cartTotal).toFixed(2)} more for 3% OFF.`;
    } else {
      msg.textContent = `✅ FREE SHIPPING and 3% OFF unlocked! Enjoy your savings!`;
    }

    // Launch confetti from 🎉 icon when hitting discount threshold first time
    if (percentage >= 100 && !confettiLaunched) {
      confettiLaunched = true;
      launchConfettiFromElement(discountEmoji);
    } else if (percentage < 100) {
      confettiLaunched = false; // reset confetti trigger if total goes below 100%
    }
  }

  // Poll cart data from Shopify
  function pollCartTotal() {
    fetch("/cart.js")
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch cart");
        return res.json();
      })
      .then(data => {
        const cartTotalDollars = data.total_price / 100;
        updateProgressBar(cartTotalDollars);
      })
      .catch(err => {
        console.error("Cart polling error:", err);
      });
  }

  // Initial poll & interval polling every 1 second for live updates
  pollCartTotal();
  setInterval(pollCartTotal, 1000);

})();




document.addEventListener('click', async (e) => {
  const button = e.target.closest('#load-more');
  if (!button) return; // not the load more button

  const grid = document.getElementById('product-grid');
  if (!grid) return;

  let url = button.dataset.nextUrl;
  if (!url) return;

  // Preserve filters from current URL
  const params = new URLSearchParams(window.location.search);
  params.delete('page'); // avoid conflicts
  if ([...params].length) {
    url += (url.includes('?') ? '&' : '?') + params.toString();
  }

  button.hidden = true;

  const html   = await fetch(url).then(r => r.text());
  const doc    = new DOMParser().parseFromString(html, 'text/html');
  const wrapper = doc.getElementById('ajax-product-wrapper');

  // Append new products
  wrapper.querySelectorAll('.grid__item').forEach(item => {
    grid.appendChild(item);
  });

  // Update button
  const nextButton = wrapper.querySelector('#load-more');
  if (nextButton) {
    button.dataset.nextUrl = nextButton.dataset.nextUrl;
    button.hidden = false;
  } else {
    button.remove();
  }
});
